import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { FormEntryPage } from '../../../../shared/pages/FormEntryPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryInputRef, SingleInputState } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { ProductModelFlow, WhereDidYouBuyFlow } from '../../pageFlowData'
import { data } from './data'

export const ProductModel: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    product,
  } = state

  const [inputData, setInputData] = useState<SingleInputState>({
    renderError: false,
    value: '',
  })
  const ProductModelInput = useRef<FormEntryInputRef>(null)

  const getValue = () => {
    return cleanText(ProductModelInput?.current?.formEntryInput?.value || '')
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${ProductModelFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_PRODUCT_MODEL', data: value })
    dispatch({ type: 'UPDATE_STEP', data: WhereDidYouBuyFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: WhereDidYouBuyFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    const value = getValue()
    const isValid: boolean = isNotEmpty(value)

    setInputData({
      renderError: !isValid,
      value: value,
    })

    if (isValid) {
      handleTracking(value)
      handleDispatch(value)
    }
  }

  const { renderError, value: errorValue } = inputData
  const { imgObj, placeholderText, title } = data

  return (
    <FormEntryPage
      buttonText="Next"
      defaultValue={product?.model}
      fieldData={{
        renderError: renderError,
        value: errorValue,
      }}
      handleSubmit={handleSubmit}
      id="product-model"
      imgObj={imgObj}
      isFocused
      placeholderText={placeholderText}
      ref={ProductModelInput}
      testId="product-model"
      title={title}
    />
  )
}
